import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import localeJsonEn from '../../locales/en.json';
import localeJsonPl from '../../locales/pl.json';
import localeJsonDe from '../../locales/de.json';

i18n.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		resources: {
			en: {
				translation: localeJsonEn,
			},
			pl: {
				translation: localeJsonPl,
			},
			de: {
				translation: localeJsonDe,
			},
		},
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
		},
	})
	.then(() => null);
